import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { AssetTypeSettingsDetailViewTopBar } from "./TopBar"

export const assetTypeSettingsDetailViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: AssetTypeSettingsDetailViewTopBar,
}
